import React from 'react'

const GreenCircleArrow = ({ className = '', color = '#4AA652' }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 6C11.25 4.60761 10.6969 3.27226 9.71231 2.28769C8.72774 1.30312 7.39239 0.75 6 0.75C4.60761 0.75 3.27226 1.30312 2.28769 2.28769C1.30312 3.27226 0.75 4.60761 0.75 6C0.75 7.39239 1.30312 8.72774 2.28769 9.71231C3.27226 10.6969 4.60761 11.25 6 11.25C7.39239 11.25 8.72774 10.6969 9.71231 9.71231C10.6969 8.72774 11.25 7.39239 11.25 6ZM0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6ZM5.625 3.375C5.625 3.27554 5.66451 3.18016 5.73483 3.10983C5.80516 3.03951 5.90054 3 6 3C6.09946 3 6.19484 3.03951 6.26516 3.10983C6.33549 3.18016 6.375 3.27554 6.375 3.375V7.71975L7.9845 6.1095C8.05491 6.03908 8.15042 5.99953 8.25 5.99953C8.34958 5.99953 8.44509 6.03908 8.5155 6.1095C8.58592 6.17991 8.62547 6.27542 8.62547 6.375C8.62547 6.47458 8.58592 6.57009 8.5155 6.6405L6.2655 8.8905C6.23067 8.92542 6.18928 8.95313 6.14373 8.97203C6.09817 8.99094 6.04933 9.00067 6 9.00067C5.95067 9.00067 5.90183 8.99094 5.85628 8.97203C5.81072 8.95313 5.76933 8.92542 5.7345 8.8905L3.4845 6.6405C3.41409 6.57009 3.37453 6.47458 3.37453 6.375C3.37453 6.27542 3.41409 6.17991 3.4845 6.1095C3.55491 6.03908 3.65042 5.99953 3.75 5.99953C3.84958 5.99953 3.94509 6.03908 4.0155 6.1095L5.625 7.71975V3.375Z"
        fill={color}
      />
    </svg>
  )
}

export default GreenCircleArrow
